import * as Sentry from '@sentry/react'
import { connect } from 'react-redux'
import dashboardApi from 'services/api/dashboard'

import LocalUserService from '../../../services/localUserService'
import ErrorPage from '../ErrorPage/index'

const userService = new LocalUserService()

const ErrorBoundary = ({ children, ...props }) => (
  <Sentry.ErrorBoundary
    fallback={<ErrorPage />}
    onError={(error, errorInfo) => {
      const { subsidiaryId, subsidiaryName, uiUserName, uiUserPhone } = props

      const errorLog = {
        level: 'Error',
        message: JSON.stringify({ error, errorInfo }),
        additionalData: {
          uiDashboardSessionId: userService.getCurrentUserInfo()?.sessionId,
          uiUserName,
          uiUserPhone,
          uiPath: document.location.pathname,
          uiSubsidiaryId: subsidiaryId,
          uiSubsidiaryName: subsidiaryName
        }
      }

      console.warn(errorLog)

      if (window.location.hostname !== 'localhost') {
        dashboardApi.log(errorLog)
      }
    }}
  >
    {children}
  </Sentry.ErrorBoundary>
)

const mapStateToProps = state => ({
  subsidiaryName: state.login.currentHotel,
  subsidiaryId: state.login.currentHotelId,
  dashboardSessionId: state.login,
  uiUserName: state.login.currentUser?.name,
  uiUserPhone: state.login.currentUser?.phone
})

export default connect(mapStateToProps)(ErrorBoundary)
